import { AdvancedSearchFilters } from 'flow/types/Tickets';

export const hasAnyAdvancedFilterActive = (filters: AdvancedSearchFilters) =>
    filters.state !== undefined ||
    filters.marked ||
    filters.since !== '' ||
    filters.assignee !== undefined ||
    (filters.tagKeysOr !== undefined && filters.tagKeysOr.length > 0);
